import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {RestCallerService} from "../rest-caller.service";
import {ImmosucheResponse} from "./model/immosuche.model";

@Injectable({
  providedIn: 'root'
})
export class ImmosucheService {
  private readonly restCallerService = inject(RestCallerService);
  private readonly serviceName = 'oekosystem-admin-v1';
  private readonly baseUrl = '/rest/de.bankenit.oekosystem.admin.v1.AdminApi/';

  ladeEinstellungenImmosuche(): Observable<ImmosucheResponse> {
    return this.restCallerService.executeGET<ImmosucheResponse>(`${this.baseUrl}admindaten/immosuche`, this.serviceName);
  }

}
